import React from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";
import Navbar from '../Navbar';
import Wallet from '../Wallet';
import Home from '../Home';
import Exchange from '../Exchange';
import '../../App.scss';
import Marketplace from '../Marketplace';

function Main() {
    return (
        <Router>
            <Navbar />    
            {/* A <Switch> looks through its children <Route>s and
                renders the first one that matches the current URL. */}
            <Switch>
                {/* <Route path="/about">
                    <About />
                </Route> */}
                <Route path='/marketplace'>
                    <Marketplace />
                </Route>
                <Route path="/wallet">
                    <Wallet />
                </Route>
                <Route exact path="/">
                    <Home />
                </Route>
                <Route exact path='/login'>
                    {/* <Login /> */}
                </Route>
                <Route path='/callback'>
                    {/* <Callback /> */}
                </Route>
                <Route path='/exchange'>
                    <Exchange />
                </Route>
            </Switch>
        </Router>
    );
}

export default Main;